import axios from 'axios';
import API_BASE_URL from './config/api';
import Cookies from 'js-cookie';

let currentUrl = API_BASE_URL;
const SHORT_GET_CACHE_TTL_MS = 3000;
const shortGetCache = new Map();

const getShortCachedRequest = (key, requestFactory) => {
	const now = Date.now();
	const cached = shortGetCache.get(key);

	if (cached && now - cached.createdAt < SHORT_GET_CACHE_TTL_MS) {
		return cached.promise;
	}

	const promise = requestFactory().catch((error) => {
		shortGetCache.delete(key);
		throw error;
	});
	shortGetCache.set(key, { createdAt: now, promise });
	return promise;
};

const clearShortCachedRequest = (keyPrefix) => {
	Array.from(shortGetCache.keys()).forEach((key) => {
		if (String(key).startsWith(keyPrefix)) {
			shortGetCache.delete(key);
		}
	});
};
//teste
// Função para gerar o cabeçalho de autenticação Basic

/* BOLETINS a*/
export const requestBoletins = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/documentos/boletins/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao receber os boletins. Tente novamente mais tarde.',
		};
	}
};

/* EVENTOS */
export const requestEvents = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/eventos/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar eventos. Tente novamente mais tarde.',
		};
	}
};

export const requestEventCreate = async (body, token) => {
	try {
		const { data } = await axios.post(`${currentUrl}/eventos/`, body, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* ATUALIZAÇÃO DO MAPA */
export const requestMapAtt = async () => {
	try {
		const { data } = await axios.get(
			`https://backend-dev.subhue.org/mapa/ultima-atualizacao-leito/`,
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar atualização do mapa. Tente novamente mais tarde.',
		};
	}
};

/* RESET PASSWORD  modify from new branch*/
export const requestResetPassword = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/auth/password-reset/`,
			body,
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNewPassword = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/auth/password-reset/confirm/`,
			body,
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* LOGIN */
export const requestAuthLogin = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/auth/login/`,
			{
				username: body.username.replace(/[-.]/g, ''),
				password: body.password,
			},
			{
				withCredentials: true,
			},
		);
		return data;
	} catch (error) {
		if (error?.response?.data?.detail) {
			return {
				error: error?.response?.data?.detail[0],
			};
		} else {
			return {
				error: error?.response?.data,
			};
		}
	}
};

export const requestUserDetails = async (token, usuario) => {
	try {
		const { data } = await axios.get(`${currentUrl}/usuarios/${usuario}/`, {
			headers: { Authorization: `Token ${token}` },
		});
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar detalhes de usuario. Tente novamente mais tarde.',
		};
	}
};

export const requestEmailSend = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/contato/enviar-email/`,
			body,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao enviar um email notificando o usuario. Tente novamente mais tarde.',
		};
	}
};

export const requestUsersCnes = async (user_token, unit_id) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/usuarios/?unidade_id=${unit_id}`,
			{
				headers: { Authorization: `Token ${user_token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response,
		};
	}
};

export const requestDetailsCnes = async (token, id) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/usuarios/?unidade_id=${id}`, // Adicionado filtro por cnes
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		console.error('Erro ao buscar detalhes de usuário:', error.message);
		return {
			error: 'Erro ao buscar detalhes de usuário para gestores. Tente novamente mais tarde.',
		};
	}
};

export const requestUpdatePerfil = async (token, username, body) => {
	try {
		// Verificar se o perfil_id está presente no corpo
		if (!body.perfil_id) {
			console.error(
				"Erro: O 'perfil_id' é obrigatório para atualizar o perfil.",
			);
			return {
				error: "O 'perfil_id' é obrigatório para atualizar o perfil.",
			};
		}

		// Log para depuração
		/* console.log('Enviando requisição para atualizar perfil:', {
			url: `${currentUrl}/usuarios/${username}/unidades/`,
			body,
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		}); */
		const { data } = await axios.put(
			`${currentUrl}/usuarios/${username}/unidades/`,
			body, // Corpo da requisição com perfil_id e demais dados
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			},
		);

		// Log de sucesso
		/* console.log('Perfil atualizado com sucesso:', data); */

		return data;
	} catch (error) {
		// Log detalhado do erro
		console.error('Erro ao atualizar perfil:', {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
			headers: error.response?.headers,
		});

		return {
			error:
				error.response?.data ||
				'Erro ao atualizar as permissões do usuário. Tente novamente mais tarde.',
		};
	}
};

export const requestDeletePerfil = async (token, username, perfilId) => {
	try {
		// Verificar se o perfilId está presente
		if (!perfilId) {
			throw new Error(
				"O 'perfil_id' é obrigatório para desativar o perfil.",
			);
		}

		// Log para depuração
		/* console.log('Enviando requisição para desativar perfil:', {
			url: `${currentUrl}/usuarios/${username}/unidades/`,
			body: { perfil_id: perfilId, ativo: false },
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		}); */

		const { data } = await axios.put(
			`${currentUrl}/usuarios/${username}/unidades/`,
			{ perfil_id: perfilId, ativo: false }, // Atualiza o status para inativo
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			},
		);

		// Log de sucesso
		/* 	console.log('Perfil desativado com sucesso:', data); */
		return data;
	} catch (error) {
		// Log detalhado do erro
		console.error('Erro ao desativar perfil:', {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
			headers: error.response?.headers,
		});

		return {
			error:
				error.response?.data ||
				'Erro ao desativar o perfil. Tente novamente mais tarde.',
		};
	}
};

export const requestUpdateRole = async (token, username, body) => {
	try {
		// Verificar se o perfil_id está presente no corpo
		if (!body.perfil_id) {
			console.error(
				"Erro: O 'perfil_id' é obrigatório para atualizar o papel.",
			);
			return {
				error: "O 'perfil_id' é obrigatório para atualizar o papel.",
			};
		}

		// Log para depuração
		/* console.log('Enviando requisição para atualizar papel:', {
			url: `${currentUrl}/usuarios/${username}/roles/`,
			body,
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		}); */

		const { data } = await axios.put(
			`${currentUrl}/usuarios/${username}/roles/`,
			body, // Corpo da requisição com perfil_id e demais dados
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			},
		);

		// Log de sucesso
		/* console.log('Papel atualizado com sucesso:', data); */
		return data;
	} catch (error) {
		// Log detalhado do erro
		console.error('Erro ao atualizar papel:', {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
			headers: error.response?.headers,
		});

		return {
			error:
				error.response?.data ||
				'Erro ao atualizar o papel do usuário. Tente novamente mais tarde.',
		};
	}
};

export const requestUserRegisters = async (body) => {
	try {
		const { data } = await axios.post(`${currentUrl}/auth/registro/`, body);
		return data;
	} catch (error) {
		let detail = '';
		if (error.response?.data?.username) {
			detail = error.response?.data?.username;
		} else if (error.response?.data?.email) {
			detail = error.response?.data?.email;
		} else if (error.response?.data?.password) {
			detail = error.response?.data?.password;
		}
		return {
			error: detail,
			detail: error.response?.data,
		};
	}
};

/* EMAIL DE SUPORTE */
export const requestEmail = async (body) => {
	try {
		const { data } = await axios.post(`${currentUrl}/contato/`, {
			nome: body.nome,
			email: body.email,
			telefone: body.telefone,
			mensagem: body.mensagem,
		});
		return data;
	} catch (error) {
		return {
			error: 'Erro ao enviar email. Tente novamente mais tarde.',
		};
	}
};

/* PUBLICAÇÕES BLOG */
export const requestPublics = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/blog/noticias/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades. Tente novamente mais tarde.',
		};
	}
};

/* UNIDADES */
export const requestPadi = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/padi/`);
		return data;
	} catch (error) {
		return {
			error: error?.response?.data,
		};
	}
};

export const requestUnitToken = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/verificar_token_unidade/`,
			body,
		);

		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestUnitSectors = async (unidade_id) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/unidades/${unidade_id}/setores/`,
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNewUnits = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/unidades/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades. Tente novamente mais tarde.',
		};
	}
};

export const requestUnits = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/unidades/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades. Tente novamente mais tarde.',
		};
	}
};

export const requestUnitsByType = async (tipo_unidade) => {
	try {
		const { data } = await axios.get(`${currentUrl}/unidades/`, {
			params: { tipo_unidade },
		});
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades por tipo. Tente novamente mais tarde.',
		};
	}
};

// NOTIFICAÇÕES

export const requestNeverevents = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/choices/?fields=sub_classificacao`,

			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestExcelExport = async (
	user_token,
	unit_token,
	initialDate,
	finalDate,
) => {
	try {
		let url = `${currentUrl}/incidentes/export/`;

		const params = new URLSearchParams();

		if (initialDate && finalDate) {
			params.append('data_notificacao_inicio', initialDate);
			params.append('data_notificacao_fim', finalDate);
		}

		if (unit_token) {
			params.append('token_notificacao', unit_token);
		}

		url += `?${params.toString()}`;

		const response = await axios.get(url, {
			headers: { Authorization: `Token ${user_token}` },
			responseType: 'blob', // ESSENCIAL!!!
		});

		return { blob: response.data };
	} catch (error) {
		console.error('Erro:', error);
		return {
			error: 'Erro ao exportar o documento. Tente novamente mais tarde.',
		};
	}
};

export const requestNoteCreate = async (body) => {
	try {
		// Construção do objeto com base nos dados recebidos
		/* console.log(body); */
		const notificationPayload = {
			token_notificacao: body.unidade_token_notificacao,
			data_ocorrencia: body.data_ocorrencia,
			notificante: body.notificador,
			notificante_setor: body.notificador_setor,
			notificante_cargo: body.notificador_cargo,
			nome_paciente: body.nome_paciente,
			nascimento_paciente: body.nascimento_paciente || null,
			prontuario: body.prontuario,
			sexo_paciente: body.sexo_paciente?.toUpperCase()[0] || '', // Valor padrão
			tipo_incidente: body.other_checked ? 'OUTROS' : body.tipo_incidente, // Se outro for marcado
			tipo_incidente_outros: body.other_checked
				? body.tipo_incidente
				: '',
			descricao: body.descricao_ocorrencia,
			acoes_imediatas: body.acoes_imediatas,
			medida_preventiva: body.medida_preventiva,
			envolve_paciente: body.envolve_paciente,
			fato_presenciado: body.fato_presenciado, // Booleano direto
			quem_presenciou:
				body.quem_presenciou === 'ninguem' ? '' : body.quem_presenciou,
			setor: body.setor,
			turno: body.turno[0],
		};

		// Configuração do cabeçalho com autenticação

		// Enviando o objeto para a API
		const { data } = await axios.post(
			`${currentUrl}/incidentes/notificacoes/`,
			notificationPayload,
		);

		return data;
	} catch (error) {
		console.error('Erro ao criar notificação:', error);
		return {
			error: error.response.data,
		};
	}
};

export const requestDelayNotes = async (token, unidade, status, atraso) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/visao-geral/?status=${status}&token_notificacao=${unidade}`,

			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar todas as notificações. Tente novamente mais tarde.',
		};
	}
};

export const requestListNotes = async (token, unidade, atraso) => {
	try {
		let url = `${currentUrl}/incidentes/notificacoes/`;
		const params = [];

		if (atraso === false) {
			params.push(`atraso=false`);
		}

		if (unidade !== undefined && unidade !== null && unidade !== '') {
			params.push(`protocolo_token_notificacao=${unidade}`);
		}

		if (params.length > 0) {
			url += `?${params.join('&')}`;
		}

		const { data } = await axios.get(url, {
			headers: { Authorization: `Token ${token}` },
		});

		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar todas as notificações. Tente novamente mais tarde.',
		};
	}
};

export const requestListNotesByProtocol = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/notificacoes/${protocolo}`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar notificações por protocolo. Tente novamente mais tarde.',
		};
	}
};

export const requestNewClassCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/classificacoes/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestClassCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/notificacoes/classificacoes/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao classificar a notificação. Tente novamente mais tarde.',
		};
	}
};

export const requestInvCreation = async (token, body, classificacao) => {
	try {
		const { data } = await axios.put(
			`${currentUrl}/notificacoes/investigacoes/${classificacao}/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNewInvCreation = async (token, protocol) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/investigacoes/`,
			{ protocolo: protocol },
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestInvByProtocol = async (token, protocol) => {
	try {
		const data = await getShortCachedRequest(
			`investigacao-protocolo|${token}|${protocol}`,
			async () => {
				const response = await axios.get(
					`${currentUrl}/incidentes/investigacoes/?protocolo=${protocol}`,
					{
						headers: { Authorization: `Token ${token}` },
					},
				);
				return response.data;
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestAllInvestigations = async (token, param) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}${
				param
					? `/incidentes/classificacoes/?protocolo__status=${param}`
					: '/incidentes/classificacoes/?investigar=true'
			}`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestAtribuirInv = async (token, protocolo, username) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/protocolo/${protocolo}/investigadores/atribuir/`,
			{ username },
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestDesativarInv = async (token, protocolo, username) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/protocolo/${protocolo}/investigadores/remover/`,
			{ username },

			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestAtribuidos = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/protocolo/${protocolo}/investigadores/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestInvestigators = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/protocolo/${protocolo}/investigadores/disponiveis/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestNotesByInv = async (token, userName) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/classificacoes/por-investigador/${userName}/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestInvConclude = async (token, id, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/investigacoes/${id}/concluir/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

/* RECUPERA OS DADOS SALVOS DE CADA PARTE DO FORMULARIO */
export const requestSavedData = async (token, id, type) => {
	try {
		const data = await getShortCachedRequest(
			`investigacao-bloco|${token}|${id}|${type}`,
			async () => {
				const response = await axios.get(
					`${currentUrl}/incidentes/investigacoes/${id}/${type}/`,
					{
						headers: { Authorization: `Token ${token}` },
					},
				);
				return response.data;
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestSaveForm = async (token, id, type, body) => {
	try {
		clearShortCachedRequest(`investigacao-bloco|${token}|${id}|${type}`);
		const { data } = await axios.post(
			`${currentUrl}/incidentes/investigacoes/${id}/${type}/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);

		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestNewAvalCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/avaliacoes-finais/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestAvalCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/notificacoes/avaliacoes-finais/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNoteTimeLine = async (protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/consulta/${protocolo}/`,
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao trazer a timeline da notificação. Tente novamente mais tarde.',
		};
	}
};

export const requestAvalList = async (token, mode) => {
	/* console.log(token, id); */
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/avaliacoes-finais/?decisao=${
				mode === 'REJEITADA' ? 'REJEITADA' : 'ACEITA'
			}`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar avaliações. Tente novamente mais tarde.',
		};
	}
};

export const requestInvList = async (token, classificacao) => {
	try {
		const response = await axios.get(
			`${currentUrl}/notificacoes/investigacoes/${classificacao}/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		/* console.log('Resposta da API:', response); */

		return response.data;
	} catch (error) {
		console.error(
			'Erro na requisição:',
			error.response?.data || error.message,
		);
		return {
			error: 'Erro ao listar investigações. Tente novamente mais tarde.',
		};
	}
};

export const requestClassDiscard = async (token, unit_token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/classificacoes/?descartar=true&unidade=${unit_token}`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar classificações descartadas. Muitas requisições',
		};
	}
};

export const requestClassByProtocol = async (token, protocol) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/classificacoes/${protocol}/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar classificações por protocolo. Muitas requisições',
		};
	}
};

export const requestNotesByProtocol = async (protocol) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/notificacoes/notificacoes/${protocol}/`,
		);

		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar notificações. Muitas requisições',
		};
	}
};

export const requestAllNotes = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/notificacoes/notificacoes/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar notificações. Muitas requisições',
		};
	}
};

/* REQUSITA AS NOTIFICAÇÕES POR UNIDADE */

/* export const requestNotesByUnit = async (protocol) => {
	try {
		const { data } = await axios.get(`${currentUrl}/notificacoes/notificacoes/`);

		console.log(data);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar notificações. Muitas requisições',
		};
	}
}; */

// DEPRECATED

export const requestNoteLogin = async (input, senha) => {
	try {
		const { data } = await axios.post(
			`http://${currentUrl}:3002/noteLogin`,
			{
				input,
				senha,
			},
		);
		return data;
	} catch (error) {
		return { error: error.message };
	}
};

export const requestLogin = async (input, senha) => {
	try {
		const { data } = await axios.post(`http://${currentUrl}:3002/login`, {
			input,
			senha,
		});
		return data;
	} catch (error) {
		return { error: error.response.data.message };
	}
};

export const requestCreate = async (body) => {
	try {
		const response = await axios.post(
			`http://${currentUrl}:3002/register`,
			body,
		);
		return { data: response.data, status: response.status };
	} catch (error) {
		return { error: error.response.data.message };
	}
};

export const requestCreateRegister = async (token, body) => {
	try {
		const response = await axios.put(
			`http://${currentUrl}:3002/register`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return response;
	} catch (error) {
		return error;
	}
};

/* export const requestGestData = async ({ token, nome }) => {
	try {
		const response = await axios.get(`http://${currentUrl}:3002/register`, {
			headers: { Authorization: `Bearer ${token}` },
			params: { nome },
		});
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
}; */

export const requestUsers = async ({ token }) => {
	try {
		const response = await axios.get(
			`http://${currentUrl}:3002/register/search`,
			{
				headers: { Authorization: `Bearer ${token}` },
			},
		);
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

export const updatePermissions = async ({ token, body }) => {
	try {
		const response = await axios.put(
			`http://${currentUrl}:3002/register/permissions`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return response;
	} catch (error) {
		return error;
	}
};

//ESCALAS
export const requestCreateScale = async (token, body) => {
	try {
		const response = await axios.post(
			`http://${currentUrl}:3002/scale`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const requestScaleData = async (body) => {
	try {
		const response = await axios.get(
			`http://${currentUrl}:3002/scale/${body.id}`,

			{
				headers: {
					Authorization: body.token,
				},
			},
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const requestAllScale = async (body) => {
	try {
		const response = await axios.get(
			`http://${currentUrl}:3002/scale/`,

			{
				headers: {
					Authorization: body.token,
				},
			},
		);
		return response;
	} catch (error) {
		return error;
	}
};

/* DASHBOARD */
export const requestDashboard = async ({ token, unitToken }) => {
	try {
		const response = await axios.get(
			unitToken.length > 0
				? `${currentUrl}/dashboards/?unidade_token=${unitToken}`
				: `${currentUrl}/dashboards`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

/* status-usuario */
export const statusUsuario = async ({ token }) => {
	try {
		const response = await axios.get(`${currentUrl}/status-usuario`, {
			headers: { Authorization: `Token ${token}` },
		});
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

/* DOCUMENTOS */
export const requestDocuments = async () => {
	const { data } = await axios.get(`http://${currentUrl}:3002/document`);
	return data;
};

/* Biblioteca SUBHUE */
export const requestBibliotecaCategorias = async () => {
	try {
		const response = await axios.get(
			`${currentUrl}/biblioteca/repositorios/`,
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

const getBibliotecaUserToken = () => {
	const userCookie = Cookies.get('user');
	if (!userCookie) return '';
	try {
		const userData = JSON.parse(userCookie);
		return String(userData?.token || '').trim();
	} catch (_error) {
		return '';
	}
};

const buildBibliotecaDocumentosParams = (id, parametros = {}) => {
	const token = getBibliotecaUserToken();
	const params = {
		repositorios: id,
		...(parametros || {}),
		ativo: true,
	};

	if (!token) {
		params.publico = true;
	} else {
		delete params.publico;
	}

	return params;
};

export const requestBibliotecaDocumentos = async (id, parametros) => {
	try {
		const response = await axios.get(
			`${currentUrl}/biblioteca/documentos/`,
			{
				params: buildBibliotecaDocumentosParams(id, parametros),
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestBibliotecaRepositorios = async () => {
	try {
		const response = await axios.get(
			`${currentUrl}/biblioteca/repositorios/`,
		);
		return response?.data;
	} catch (error) {
		return {
			error: error?.response?.data,
		};
	}
};
/*Buscar lista de arquivos por categoria ID*/
export const requestBibliotecaDocumentosId = async (id) => {
	try {
		const response = await axios.get(
			`${currentUrl}/biblioteca/documentos/${id}`,
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/*Buscar lista de arquivos por categoria ID*/
export const requestBibliotecaDocumentosIdToken = async (id, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/biblioteca/documentos/${id}`,
			{ headers },
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};
/*Buscar lista de arquivos por categoria ID*/
export const requestBibliotecaAllDocumentosList = async (id) => {
	try {
		const response = await axios.get(
			`${currentUrl}/biblioteca/repositorios/${id}/documentos/`,
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const bibliotecaRepositoriosTemas = async (id, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/biblioteca/repositorios/${id}/temas/`,
			{ headers },
		);
		return response?.data;
	} catch (error) {
		return {
			error: error?.response?.data,
		};
	}
};

export const bibliotecaRepositoriosCategorias = async (id, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/biblioteca/repositorios/${id}/categorias/`,
			{ headers },
		);
		return response?.data;
	} catch (error) {
		return {
			error: error?.response?.data,
		};
	}
};

export const bibliotecaPublicosAlvos = async (id, token = null) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/biblioteca/publicos-alvo/`,
			{ headers },
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/*Lista de todos os documentos*/
export const requestBibliotecaDocumentosAllList = async (search, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/biblioteca/documentos/`,
			{
				params: search,
				headers,
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* Edição de Documentos da Biblioteca */
export const requestBibliotecaDocumentosEdit = async (id, body, token) => {
	try {
		const headers = {
			Authorization: `Token ${token}`,
			Accept: 'application/json',
		};

		// Só define Content-Type se NÃO for FormData
		if (!(body instanceof FormData)) {
			headers['Content-Type'] = 'application/json';
		}

		const { data } = await axios.patch(
			`${currentUrl}/biblioteca/documentos/${id}/`,
			body,
			{ headers },
		);

		return data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
			status: error.response?.status,
		};
	}
};

/* Criar um novo documento na Biblioteca */
export const requestBibliotecaDocumentosCreate = async (data, token) => {
	try {
		const response = await axios.post(
			`${currentUrl}/biblioteca/documentos/`,
			data,
			{
				headers: {
					Authorization: `Token ${token}`, // Certifique-se que o token está correto
					Accept: 'application/json',
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			// Erros retornados pelo backend
			return { error: error.response.data || error.response.statusText };
		} else {
			// console.log(error)
			// Erros de rede ou outros
			return { error: error.message };
		}
	}
};

/*Lista de todos  as categorias*/
export const requestBibliotecaCategoriasList = async (search, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/biblioteca/categorias`,
			{
				params: { search },
				headers,
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/*Lista de todos  os temas*/
export const requestBibliotecaTemasList = async (search, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(`${currentUrl}/biblioteca/temas`, {
			params: { search },
			headers,
		});
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/*Painel - Ocupação de Leitos*/

/*Lista de ocupação de leitos*/
export const requestOcupationdeLeitos = async (filters, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/painel/ocupacao-leitos/`,
			{
				params: filters,
				paramsSerializer: { indexes: null },
				headers,
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/*Opções de filtros para ocupação de leitos - UNIDADES - ENFERMARIAS - SECCOES*/
export const requestOcupacaoLeitosOptions = async (token, params = {}) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/painel/ocupacao-leitos/options/`,
			{
				params,
				// O endpoint aceita múltiplos valores repetindo o mesmo parâmetro.
				paramsSerializer: { indexes: null },
				headers,
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

/* Opções de filtros exclusivas para a série histórica de ocupação de leitos */
export const requestOcupacaoLeitosHistoricoOptions = async (
	token,
	params = {},
) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/painel/ocupacao-leitos/historico/options/`,
			{
				headers,
				params,
				// As facetas aceitam múltiplos valores para o mesmo parâmetro.
				// `indexes: null` mantém o formato `unidade=a&unidade=b`,
				// esperado pelo endpoint.
				paramsSerializer: { indexes: null },
			},
		);
		return response.data;
	} catch (error) {
		console.error(
			'Erro ao carregar opções do histórico de ocupação:',
			error,
		);
		return { error: error.response?.data || error.message };
	}
};

/*Grafico  - série Histórica de ocupação de leitos*/
export const requestOcupationdeLeitosGrafico = async (filters, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/painel/ocupacao-leitos/historico/`,
			{
				params: filters,
				paramsSerializer: { indexes: null },
				headers,
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

/* Exportar excel - Ocupação de Leitos */
export const requestOcupationdeLeitosExcel = async (filters, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/painel/ocupacao-leitos/export/`,
			{
				params: filters,
				paramsSerializer: { indexes: null },
				headers,
				responseType: 'blob',
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

/* Exportar excel - Série Histórica de Ocupação de Leitos */
export const requestOcupationdeLeitosGraficoExcel = async (filters, token) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const response = await axios.get(
			`${currentUrl}/painel/ocupacao-leitos/historico/export/`,
			{
				params: filters,
				paramsSerializer: { indexes: null },
				headers,
				responseType: 'blob',
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

// Obter opções de filtros para doenças e agravos
export const requestDoencasAgravosOptions = async (token, params = {}) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const url = `${API_BASE_URL}/api/doencas-agravos/opcoes/${
			queryParams ? `?${queryParams}` : ''
		}`;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Erro ao buscar opções de filtros:', error);
		return { error: true, message: error.message };
	}
};

// Obter dados de doenças e agravos
export const requestDoencasAgravos = async (filters = {}, token) => {
	try {
		const queryParams = new URLSearchParams(filters).toString();
		const url = `${API_BASE_URL}/api/doencas-agravos/${
			queryParams ? `?${queryParams}` : ''
		}`;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Erro ao buscar dados de doenças:', error);
		return { error: true, message: error.message };
	}
};

// Obter série histórica de doenças e agravos
export const requestDoencasAgravosGrafico = async (filters = {}, token) => {
	try {
		const queryParams = new URLSearchParams(filters).toString();
		const url = `${API_BASE_URL}/api/doencas-agravos/historico/${
			queryParams ? `?${queryParams}` : ''
		}`;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error('Erro ao buscar série histórica:', error);
		return { error: true, message: error.message };
	}
};

// Exportar dados de doenças e agravos para Excel
export const requestDoencasAgravosExcel = async (filters = {}, token) => {
	try {
		const queryParams = new URLSearchParams(filters).toString();
		const url = `${API_BASE_URL}/api/doencas-agravos/export/${
			queryParams ? `?${queryParams}` : ''
		}`;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.blob();
	} catch (error) {
		console.error('Erro ao exportar dados:', error);
		return null;
	}
};

// Exportar série histórica de doenças e agravos para Excel
export const requestDoencasAgravosGraficoExcel = async (
	filters = {},
	token,
) => {
	try {
		const queryParams = new URLSearchParams(filters).toString();
		const url = `${API_BASE_URL}/api/doencas-agravos/historico/export/${
			queryParams ? `?${queryParams}` : ''
		}`;
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.blob();
	} catch (error) {
		console.error('Erro ao exportar série histórica:', error);
		return null;
	}
};

/*Responsável por buscar a lista de huddles. Retorna todos os huddles cadastrados no sistema para exibição e controle.*/
export const requestHuddles = async (
	token = null,
	{ data_inicio, data_fim, lider, unidade_id } = {},
) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};

		const params = {};
		if (data_inicio) params.data_inicio = data_inicio;
		if (data_fim) params.data_fim = data_fim;
		if (lider) params.lider = lider;
		if (unidade_id) params.unidade = unidade_id;

		const { data } = await axios.get(`${currentUrl}/huddle/huddles/`, {
			headers,
			params,
		});

		return data;
	} catch (error) {
		console.error(
			'requestHuddles erro:',
			error.response || error.message || error,
		);
		return {
			error:
				error?.response?.data ||
				error?.response?.statusText ||
				'Erro ao receber os huddles. Tente novamente mais tarde.',
			status: error?.response?.status,
		};
	}
};

export const requestHuddlesExcel = async (
	token = null,
	{ data_hora_inicio, data_hora_fim, lider, unidade_id } = {},
) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};

		const params = {};
		if (data_hora_inicio) params.data_inicio = data_hora_inicio;
		if (data_hora_fim) params.data_fim = data_hora_fim;
		if (lider) params.lider = lider;
		if (unidade_id) params.unidade_id = unidade_id;
		const { data } = await axios.get(
			`${currentUrl}/huddle/huddles/export-excel/`,
			{
				headers,
				params,
				responseType: 'blob', // ESSENCIAL!!!
			},
		);

		return data;
	} catch (error) {
		console.error(
			'requestHuddles erro:',
			error.response || error.message || error,
		);
		return {
			error:
				error?.response?.data ||
				error?.response?.statusText ||
				'Erro ao receber os huddles. Tente novamente mais tarde.',
			status: error?.response?.status,
		};
	}
};

/* Criar um novo huddle */
export const requestHuddleCreate = async (body, token) => {
	try {
		/* console.log('TOKEN USADO =', finalToken);
		for (let [k, v] of body.entries()) {
			console.log('FormData ->', k, v);
		} */

		// Se for FormData (contém arquivo), não definir Content-Type explicitamente

		const isForm =
			typeof FormData !== 'undefined' && body instanceof FormData;
		const headers = { Authorization: `Token ${token}` };
		// Logar diagnóstico do body para identificar problemas de payload
		try {
			if (isForm) {
				// listar chaves do FormData
				const keys = [];
				for (let pair of body.entries()) {
					keys.push(pair[0]);
				}
				console.log(
					'requestHuddleCreate: enviando FormData com chaves=',
					keys,
				);
			} else {
				console.log('requestHuddleCreate: enviando JSON body=');
			}
		} catch (e) {
			console.warn(
				'requestHuddleCreate: falha ao logar body do request',
				e,
			);
		}

		const { data } = await axios.post(
			`${currentUrl}/huddle/huddles/`,
			body,
			{ headers },
		);

		return data;
	} catch (error) {
		console.error(
			'requestHuddleCreate erro:',
			error.response || error.message || error,
		);

		// retornar detalhe completo para o frontend exibir mensagens por campo
		return {
			error:
				error?.response?.data ||
				error?.message ||
				'Erro ao criar o huddle. Tente novamente mais tarde.',
			status: error?.response?.status,
			raw: error?.response,
		};
	}
};

/* Buscar schema (configuração) do formulário por unidade e número do huddle */
export const requestHuddleSchema = async (
	unidade_id,
	numero_huddle,
	token = null,
) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const params = {};
		if (unidade_id) params.unidade_id = unidade_id;
		if (numero_huddle) params.numero_huddle = numero_huddle;

		const { data } = await axios.get(`${currentUrl}/huddle/schema/`, {
			headers,
			params,
		});
		return data;
	} catch (error) {
		console.error(
			'requestHuddleSchema erro:',
			error.response || error.message || error,
		);
		return { error: error?.response?.data || 'Erro ao buscar schema.' };
	}
};

/* Buscar lista global de especialidades (fallback) */
export const requestHuddleEspecialidades = async (token = null) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const { data } = await axios.get(
			`${currentUrl}/huddle/especialidades/`,
			{ headers },
		);
		return data;
	} catch (error) {
		console.error(
			'requestHuddleEspecialidades erro:',
			error.response || error.message || error,
		);
		return {
			error: error?.response?.data || 'Erro ao buscar especialidades.',
		};
	}
};

/* Buscar número sugerido para o huddle (1 ou 2) baseado no histórico do dia */
export const requestHuddleNumeroSugerido = async (unidade_id, token = null) => {
	try {
		const headers = token ? { Authorization: `Token ${token}` } : {};
		const params = {};
		if (unidade_id) params.unidade_id = unidade_id;
		const { data } = await axios.get(
			`${currentUrl}/huddle/numero-sugerido/`,
			{ headers, params },
		);
		return data; // espera-se { numero: 1 } ou { numero: 2 } ou similar
	} catch (error) {
		console.error(
			'requestHuddleNumeroSugerido erro:',
			error.response || error.message || error,
		);
		return {
			error: error?.response?.data || 'Erro ao buscar número sugerido.',
		};
	}
};

/* Detalhe de um huddle */
export const requestHuddleDetail = async (id, token = null) => {
	try {
		let finalToken = token;
		if (!finalToken) {
			const userCookie = Cookies.get('user');
			finalToken = userCookie ? JSON.parse(userCookie).token : null;
		}
		const headers = finalToken
			? { Authorization: `Token ${finalToken}` }
			: {};
		const { data } = await axios.get(
			`${currentUrl}/huddle/huddles/${id}/`,
			{ headers },
		);
		return data;
	} catch (error) {
		console.error(
			'requestHuddleDetail erro:',
			error.response || error.message || error,
		);
		return {
			error: error?.response?.data || 'Erro ao buscar detalhe do huddle.',
		};
	}
};
/* Detalhe de um huddle */
export const requestHuddleNumberSugest = async (unit_id, token = null) => {
	try {
		let finalToken = token;
		if (!finalToken) {
			const userCookie = Cookies.get('user');
			finalToken = userCookie ? JSON.parse(userCookie).token : null;
		}
		const headers = finalToken
			? { Authorization: `Token ${finalToken}` }
			: {};
		const { data } = await axios.get(
			`${currentUrl}/huddle/numero-sugerido/`,
			{ headers, params: { unidade_id: unit_id } },
		);
		return data;
	} catch (error) {
		console.error(
			'requestHuddleNumberSugest erro:',
			error.response || error.message || error,
		);
		return {
			error: error?.response?.data || 'Erro ao buscar número sugerido.',
		};
	}
};

/* Atualizar (patch) um huddle existente */
export const requestHuddleUpdate = async (id, body, token) => {
	try {
		// Detecta se é FormData (tem arquivo)
		const isForm =
			typeof FormData !== 'undefined' && body instanceof FormData;

		const headers = {
			Authorization: `Token ${token}`,
			...(isForm ? {} : { 'Content-Type': 'application/json' }),
		};

		// Log diagnóstico
		try {
			if (isForm) {
				const keys = [];
				for (let pair of body.entries()) {
					keys.push(pair[0]);
				}
				console.log(
					'requestHuddleUpdate: enviando FormData com chaves=',
					keys,
				);
			} else {
				console.log('requestHuddleUpdate: enviando JSON body=');
			}
		} catch (e) {
			console.warn(
				'requestHuddleUpdate: falha ao logar body do request',
				e,
			);
		}

		const { data } = await axios.patch(
			`${currentUrl}/huddle/huddles/${id}/`,
			body,
			{ headers },
		);

		return data;
	} catch (error) {
		console.error(
			'requestHuddleUpdate erro:',
			error.response || error.message || error,
		);

		return {
			error:
				error?.response?.data ||
				error?.message ||
				'Erro ao atualizar o huddle.',
			status: error?.response?.status,
			raw: error?.response,
		};
	}
};

/* EDITA O SETOR NAS ETAPAS DA NOTIFICAÇÃO ATRAVES */
export const requestEditSetor = async (token, protocolo, body) => {
	try {
		const response = await axios.patch(
			`${currentUrl}/incidentes/notificacoes/${protocolo}/setor/`,
			body, // ✅ body vem aqui
			{
				headers: {
					Authorization: `Token ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

export const requestNoteDelete = async (token, protocolo) => {
	try {
		const response = await axios.post(
			`${currentUrl}/incidentes/${protocolo}/solicitar-exclusao/`,
			{
				headers: { Authorization: `Bearer ${token}` },
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

/* UPDATE DE PLANO DE AÇÃO */
export const requestPAUpdate = async (token, body, id) => {
	try {
		const response = await axios.patch(
			`${currentUrl}/incidentes/planos-acao/${id}/status/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};

/* RESUMO DE PLANO DE AÇÃO*/
export const requestPAResume = async (token, id) => {
	try {
		const response = await axios.get(
			`${currentUrl}/incidentes/visao-geral/concluidos-resumo/?plano_pendente=true&token_notificacao=${id}`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return response.data;
	} catch (error) {
		return {
			error: error.response?.data || error.message,
		};
	}
};
